<template>
    <div>
        <app-input id="name" v-model="form.name" name="name" rules="required">
            <template #label>
                {{ $t('Name') }}*
            </template>
        </app-input>
    </div>
</template>

<script>
export default {
    name: 'MakeForm',
    props: {
        form: Object
    }
};
</script>
